<template>
  <div class="flex app-content-back container mx-auto">
    <div
      v-if="player"
      class="flex-col m-12 w-full"
    >
      <h2 class="bg-green-600 text-white p-2 pl-2 py-1 mb-1 text-xl flex-grow">
        Profil - {{ player.name }}
      </h2>

      <div class="flex flex-row mb-8 ">
        <div class="ctl-edit-container mr-6 w-16">
          <input
            v-model="player.birthYear"
            class="ctl-edit"
          >
        </div>

        <div class="ctl-edit-container">
          <input
            v-model="player.name"
            type="text"
            class="ctl-edit"
          >
        </div>
      </div>

      <div>
        <label class="block text-gray-700 text-sm font-bold mb-2">
          Teams
        </label>

        <div class="mb-8 flex flex-col">
          <div
            v-for="team in player.teams"
            :key="team.teamId"
            class="flex w-64 overflow-hidden"
          >
            <span class="flex-grow text-xl">{{ team.name }}</span> <i
              class="fas fa-2x fa-sign-out-alt cursor-pointer text-red-600 "
              @click="leaveTeam(team.teamId)"
            />
          </div>

          <div class="flex flex-col w-128">
            <div class="ctl-edit-container mr-6 w-1/2 mb-6">
              <input
                v-model="teamToJoin"
                class="ctl-edit w-16"
                placeholder="TeamId"
                @change="suggestTeam"
              >
              <i
                class="fas fa-2x fa-search cursor-pointer text-red-600 "
                @click="suggestTeam()"
              />
            </div>

            <div
              v-if="teamSuggestion"
              class=" flex flex-col"
            >
              <label class="block text-gray-700 text-sm font-bold mb-2">
                Teams für {{ teamToJoin }}
              </label>
              <div
                v-for="team in teamSuggestion"
                :key="team.id"
              >
                <button
                  class="save-button hover:bg-primary-700 hover:border-primary-700 w-32"
                  type="button"
                  @click="joinTeam(team.id)"
                >
                  {{ team.name }} beitreten
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <label class="block text-gray-700 text-sm font-bold mb-2">
          E-Mail Adressen <i
            v-if="player.emailAddresses && player.emailAddresses.length>0"
            class="fas fa-copy cursor-pointer"
            @click="clipMails(player.emailAddresses)"
          />
        </label>
        <div class="mb-4 flex flex-col">
          <div
            v-for="mail in player.emailAddresses"
            :key="mail"
            class="items.center mb-1"
          >
            <i
              class="mr-2 fas fa-trash cursor-pointer  "
              @click="removeEmail(mail)"
            /><span @click="clipMails([mail])">{{ mail }}</span>
          </div>
        </div>
        <div class="ctl-edit-container ">
          <input
            v-model="newMail"
            class="ctl-edit"
            placeholder="Weitere E-Mail eingeben"
          >

          <button
            class="save-button  hover:bg-primary-700 hover:border-primary-700"
            type="button"
            @click="saveEmail"
          >
            Speichern
          </button>
        </div>
      </div>

      <h2 class="bg-green-600 text-white p-2 pl-2 py-1 mb-1 text-xl flex-grow mt-16">
        Trainings-Historie
      </h2>

      <div class="flex flex-col">
        <div
          v-for="potential in player.participatedSessions"
          :key="potential.id"
          class="flex flex-row mb-2"
        >
          <router-link
            class="flex flex-row flex-grow"
            :to="{name:'training.feedback',params:{id:potential.id}}"
          >
            <span class=" mr-2 font-bold">{{ potential.date | formatDate }}</span>
            <div class="flex-grow">
              {{ potential.title }}
            </div>
          </router-link>

          <div class="flex flex-row ml-2">
            <span
              v-for="name in potential.tags.emphasized"
              :key="name"
              class="tag"
            >{{ name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '../api/apiService'
import mailFormatter from '../mailFormatter'

export default {
    name: 'PlayerProfile',
    data () {
        return {
            newMail: '',
            playerId: null,
            player: null,
            teamToJoin: null,
            teamSuggestion: null
        }
    },
    async mounted () {
        this.playerId = this.$route.params.id
        await this.loadPlayer()
    },
    methods: {
        clipMails (mails) {
            mailFormatter.copyMails(mails)
        },
        async suggestTeam () {
            const response = await apiService.suggestTeam(this.teamToJoin)

            this.teamSuggestion = response.data
            console.log(response)
        },
        async loadPlayer () {
            const response = await apiService.getPlayerProfile(this.playerId)

            response.data.potentialTrainingSessions.forEach(function (potential) {
                var participation = response.data.participatedSessions.find(obj => {
                    return obj.id === potential.id
                })

                if (participation) {
                    potential.wasPresent = true
                }
                potential.participation = participation
            })

            this.player = response.data
        },
        async leaveTeam (team) {
            await apiService.removeTeamFromPlayer(this.playerId, team)
            await this.loadPlayer()
        },
        async removeEmail (email) {
            await apiService.removeEmail(this.playerId, email)
            this.loadPlayer()
        },

        async joinTeam (team) {
            await apiService.assignTeamToPlayer(this.playerId, team)
            this.teamToJoin = null
            this.teamSuggestion = null
            await this.loadPlayer()
        },
        participationById (sessionId) {
            var result = this.player.participatedSessions.find(obj => {
                return obj.id === sessionId
            })

            return result
        },
        async saveEmail () {
            if (this.newMail.length > 3) {
                await apiService.addEmail(this.playerId, this.newMail)
                this.newMail = ''

                this.loadPlayer()
            }
        }

    }

}
</script>

<style scoped>

</style>